import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function SettingsPage() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ color: 'var(--grey-900)', mb: 1 }}>
        Settings
      </Typography>
      <Typography sx={{ color: 'var(--grey-500)', fontSize: '0.875rem' }}>
        Coming Soon
      </Typography>
      <Box component="ul" sx={{ mt: 1, pl: 3 }}>
        {[
          'Warehouses: list of warehouse locations, add / edit / deactivate',
          'Suppliers: list of vendors / suppliers, add / edit / deactivate',
          'Users: list of users and roles, invite / edit / deactivate',
          'Notifications: rules for SLA breach, low stock, shipment delay, RMA created',
          'Integrations: ServiceHub, carrier integrations (FedEx, UPS), add new integration',
        ].map((item) => (
          <Box component="li" key={item}>
            <Typography sx={{ color: 'var(--grey-500)', fontSize: '0.875rem' }}>
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
